// Per-tool help clips shown inside the tool tooltips on the Design Canvas (REF-6263).
// Hosted on app_cdn; uploaded with "keep original filename" so the slug == the filename.
// The Tooltip `video` prop hides itself if a URL 404s, so an unmapped/unhosted tool degrades to text.
const BASE = "https://storage.googleapis.com/app_cdn/statics";
// Bucket blocks overwriting an existing object (403), so the audio re-upload lands under a "-v2" name.
const VERSION = "-v2";
const v = (slug: string) => `${BASE}/${slug}${VERSION}.webm`;

export const DC_HELP_VIDEO = {
  helpButton: v("design-canvas-help-button"),
  photoshootTools: v("design-canvas-photoshoot-tools"),
  view360: v("design-canvas-360-view"),
  addPrint: v("design-canvas-add-print"),
  adjustImage: v("design-canvas-adjust-image"),
  animate: v("design-canvas-animate"),
  changeBackground: v("design-canvas-change-background"),
  checkSimilarity: v("design-canvas-check-similarity"),
  convertToSketch: v("design-canvas-convert-to-sketch"),
  denimLaserPrint: v("design-canvas-denim-laser-print"),
  editSelection: v("design-canvas-edit-and-selection-tools"),
  moodboard: v("design-canvas-moodboard"),
  generateWithReference: v("design-canvas-generate-with-reference"),
  history: v("design-canvas-history"),
  makeSeamless: v("design-canvas-make-seamless-print"),
  printExtract: v("design-canvas-print-extract-from-photo"),
  promptAssistant: v("design-canvas-prompt-assistant"),
  recolor: v("design-canvas-recolor"),
  removeBackground: v("design-canvas-remove-background"),
  sketchToDesign: v("design-canvas-sketch-to-design"),
  techPackSvg: v("design-canvas-tech-pack-svg"),
  trendAgent: v("design-canvas-trend-agent"),
  editAndVariate: v("design-canvas-edit-and-variate"),
} as const;

export type DcHelpVideoKey = keyof typeof DC_HELP_VIDEO;

/**
 * Each clip's backoffice "Site Görselleri" slot (the url above is its fallback). Resolved where the clip plays:
 * `Tooltip` looks the url up (`components/Tooltip/helpVideoSlots`), so call sites keep passing `DC_HELP_VIDEO.*`.
 */
export const DC_HELP_VIDEO_SLOT: Record<DcHelpVideoKey, string> = {
  helpButton: "canvas_help.design_canvas_help_button",
  photoshootTools: "canvas_help.design_canvas_photoshoot_tools",
  view360: "canvas_help.design_canvas_360_view",
  addPrint: "canvas_help.design_canvas_add_print",
  adjustImage: "canvas_help.design_canvas_adjust_image",
  animate: "canvas_help.design_canvas_animate",
  changeBackground: "canvas_help.design_canvas_change_background",
  checkSimilarity: "canvas_help.design_canvas_check_similarity",
  convertToSketch: "canvas_help.design_canvas_convert_to_sketch",
  denimLaserPrint: "canvas_help.design_canvas_denim_laser_print",
  editSelection: "canvas_help.design_canvas_edit_and_selection_tools",
  moodboard: "canvas_help.design_canvas_moodboard",
  generateWithReference: "canvas_help.design_canvas_generate_with_reference",
  history: "canvas_help.design_canvas_history",
  makeSeamless: "canvas_help.design_canvas_make_seamless_print",
  printExtract: "canvas_help.design_canvas_print_extract_from_photo",
  promptAssistant: "canvas_help.design_canvas_prompt_assistant",
  recolor: "canvas_help.design_canvas_recolor",
  removeBackground: "canvas_help.design_canvas_remove_background",
  sketchToDesign: "canvas_help.design_canvas_sketch_to_design",
  techPackSvg: "canvas_help.design_canvas_tech_pack_svg",
  trendAgent: "canvas_help.design_canvas_trend_agent",
  editAndVariate: "canvas_help.design_canvas_edit_and_variate",
};
